module.exports = __webpack_public_path__ + "images/feed-info37664ae315d3b0c491a4ef9fe971bf13.svg";